module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/accessible@2x-f9072e25aea45973eff67f34fc44de7d.png";